import { render, staticRenderFns } from "./ArticleThumb.vue?vue&type=template&id=02a0ee61&"
import script from "./ArticleThumb.vue?vue&type=script&lang=js&"
export * from "./ArticleThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports